// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codd-map-workspace {
  position: relative;
  height: calc(100vh - 56px);
  min-height: 720px;
  overflow: hidden;
  background: #dbe4ee;
}

.codd-map-canvas {
  height: 100%;
  width: 100%;
}

.codd-top-left-rail {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.codd-settings-trigger {
  position: static;
}

.codd-search-trigger {
  position: static;
  display: flex;
  align-items: center;
  gap: 8px;
}

.factor-data-source-status {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  max-width: 250px;
  padding: 7px 10px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.92);
  color: #f8fafc;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
}

.factor-data-source-status.is-ready {
  border-color: #34d399;
}

.factor-data-source-status.is-partial {
  border-color: #fbbf24;
}

.factor-data-source-status.is-error {
  border-color: #fb7185;
}

.map-load-indicator {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  color: #e2e8f0;
}

.map-load-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(226, 232, 240, 0.34);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: codd-map-spin 0.8s linear infinite;
}

.map-load-public-text {
  padding: 7px 9px;
  border-radius: 7px;
  background: rgba(15, 23, 42, 0.9);
  color: #f8fafc;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.2;
  white-space: nowrap;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
}

.map-load-progress-wrap {
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
}

.map-load-progress-track {
  display: block;
  width: 100%;
  height: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(226, 232, 240, 0.38);
}

.map-load-progress-value {
  display: block;
  height: 100%;
  min-width: 0;
  border-radius: inherit;
  background: #34d399;
  transition: width 650ms cubic-bezier(0.22, 1, 0.36, 1);
}

.map-load-developer-text {
  max-width: 250px;
  padding: 6px 8px;
  border-radius: 7px;
  background: rgba(15, 23, 42, 0.9);
  color: #f8fafc;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

@keyframes codd-map-spin {
  to { transform: rotate(360deg); }
}

.codd-top-right-rail {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
}

.codd-data-source-switch {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 7px 10px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 8px;
  background: rgba(17, 24, 39, 0.92);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.15;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
}

.codd-data-source-switch input {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: #22c55e;
  cursor: pointer;
}

.codd-date-trigger,
.codd-road-date-trigger,
.codd-district-trigger {
  position: static;
  display: flex;
  align-items: center;
  gap: 8px;
}

.codd-period-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  max-width: 260px;
}

.codd-date-panel {
  border-top: none;
  padding-top: 0;
}

.codd-date-summary,
.codd-road-year-summary {
  max-width: 240px;
  padding: 0;
  border: none;
  border-radius: 0;
  background: none;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-align: right;
  text-shadow:
    -1px -1px 0 rgba(15, 23, 42, 0.95),
    1px -1px 0 rgba(15, 23, 42, 0.95),
    -1px 1px 0 rgba(15, 23, 42, 0.95),
    1px 1px 0 rgba(15, 23, 42, 0.95),
    0 1px 2px rgba(15, 23, 42, 0.9);
}

.codd-road-year-summary {
  opacity: 0.95;
}

.codd-settings-sheet {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #1d1d1d;
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
}

.codd-drawer-backdrop {
  position: absolute;
  inset: 0;
  z-index: 1090;
  background: rgba(15, 23, 42, 0.32);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.codd-drawer-backdrop.is-open {
  opacity: 1;
  pointer-events: auto;
}

.codd-drawer {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1100;
  width: min(420px, calc(100vw - 24px));
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  transition: transform 0.25s ease;
}

.codd-drawer-left {
  left: 0;
  transform: translateX(-102%);
}

.codd-drawer-right {
  right: 0;
  transform: translateX(102%);
}

.codd-drawer.is-open {
  transform: translateX(0);
}

.codd-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid #e5e7eb;
}

.codd-drawer-title {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
}

.codd-drawer-close {
  border: none;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  padding: 0;
  background: rgba(17, 24, 39, 0.94);
  color: #fff;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
}

.codd-drawer-close:hover {
  background: rgba(31, 41, 55, 0.98);
}

.codd-drawer-close svg {
  flex: 0 0 auto;
}

.codd-drawer-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow: auto;
  padding: 16px 18px 20px;
}

.codd-bottom-stack {
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.codd-legend-slot {
  width: min(320px, calc(100vw - 24px));
}

.factor-selection-drawer {
  --factor-tab-height: 42px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  width: 100%;
  transform: translateY(calc(100% - var(--factor-tab-height)));
  transition: transform 260ms ease;
  pointer-events: none;
}

.factor-selection-drawer.is-open {
  transform: translateY(0);
}

.factor-selection-tab {
  position: relative;
  width: min(240px, 70%);
  min-height: var(--factor-tab-height);
  margin: 0 auto;
  padding: 7px 14px 8px;
  border: 1px solid rgba(148, 163, 184, 0.75);
  border-bottom: none;
  border-radius: 14px 14px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.98);
  color: #0f172a;
  box-shadow: 0 -8px 22px rgba(15, 23, 42, 0.14);
  cursor: pointer;
  font-family: "Segoe UI", Tahoma, sans-serif;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: auto;
}

.factor-selection-drawer.is-open .factor-selection-tab {
  cursor: ns-resize;
}

.factor-selection-tab-grip {
  position: absolute;
  top: 5px;
  width: 42px;
  height: 4px;
  border-radius: 999px;
  background: #cbd5e1;
}

.factor-selection-tab-icon {
  width: 13px;
  height: 13px;
  border-top: 3px solid #0f172a;
  border-left: 3px solid #0f172a;
  transform: rotate(45deg) translateY(2px);
  transition: transform 180ms ease;
}

.factor-selection-drawer.is-open .factor-selection-tab-icon {
  transform: rotate(225deg) translateY(-2px);
}

.factor-selection-drawer.is-open .factor-selection-tab {
  border-color: #cbd5e1;
  box-shadow: 0 -4px 14px rgba(15, 23, 42, 0.1);
}

.factor-selection-sheet {
  display: flex;
  flex-direction: column;
  max-height: min(42vh, 390px);
  overflow: auto;
  padding: 12px 18px;
  border: 1px solid rgba(148, 163, 184, 0.75);
  border-left: none;
  border-right: none;
  border-radius: 14px 14px 0 0;
  background: rgba(255, 255, 255, 0.97);
  color: #1f2937;
  box-shadow: 0 -12px 32px rgba(15, 23, 42, 0.18);
  font-family: "Segoe UI", Tahoma, sans-serif;
  pointer-events: auto;
}

.factor-selection-drawer.is-resized .factor-selection-sheet {
  height: var(--factor-selection-sheet-height);
  max-height: min(72vh, calc(100vh - 120px));
}

.factor-selection-drawer.is-collapsed .factor-selection-sheet {
  pointer-events: none;
}

.factor-selection-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 4px;
}

.factor-selection-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.factor-selection-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.9fr) minmax(280px, 0.9fr);
  gap: 12px;
  align-items: stretch;
}

.factor-selection-chart-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.factor-selection-card {
  min-width: 0;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: rgba(248, 250, 252, 0.78);
}

.factor-selection-card.is-chart {
  display: flex;
  flex-direction: column;
}

.factor-selection-card-wide {
  grid-column: span 2;
}

.factor-selection-card.is-table {
  padding: 0;
  background: transparent;
}

.factor-selection-card-title {
  margin-bottom: 8px;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.factor-selection-card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
  padding: 0 2px;
}

.factor-selection-card-title-row .factor-selection-card-title {
  margin-bottom: 0;
}

.factor-selection-card.is-table .factor-selection-card-title {
  padding: 0 2px;
}

.factor-selection-empty {
  min-height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
  background: rgba(255, 255, 255, 0.72);
}

.factor-selection-export-btn {
  flex: 0 0 auto;
  min-height: 26px;
  padding: 4px 9px;
  border: 1px solid #bfdbfe;
  border-radius: 7px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.factor-selection-export-btn:hover:not(:disabled) {
  border-color: #93c5fd;
  background: #dbeafe;
}

.factor-selection-export-btn:disabled {
  cursor: wait;
  opacity: 0.55;
}

.factor-selection-note {
  margin-bottom: 8px;
  color: #64748b;
  font-size: 12px;
}

.factor-selection-note.is-placeholder {
  color: #dc2626;
  font-weight: 800;
}

.factor-selection-table-wrap {
  flex: 1 1 auto;
  max-height: min(30vh, 270px);
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.84);
}

.factor-selection-drawer.is-resized .factor-selection-table-wrap {
  max-height: none;
}

.factor-selection-table {
  width: 100%;
  min-width: 540px;
  border-collapse: collapse;
  font-size: 12px;
  line-height: 1.35;
}

.factor-selection-table th,
.factor-selection-table td {
  min-width: 140px;
  max-width: 220px;
  padding: 6px 8px;
  border-bottom: 1px solid #e5e7eb;
  border-right: 1px solid #eef2f7;
  text-align: left;
  vertical-align: top;
}

.factor-selection-table th:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 96px;
  background: #f8fafc;
  color: #0f172a;
}

.factor-selection-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8fafc;
  color: #0f172a;
}

.factor-selection-table thead th:first-child {
  z-index: 3;
}

.factor-accident-chart {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  gap: 8px;
  overflow-x: auto;
  padding: 8px 6px 0;
}

.factor-accident-bar-item {
  flex: 1 1;
  min-width: 28px;
  max-width: 74px;
  height: 100%;
  min-height: 150px;
  display: grid;
  grid-template-rows: auto minmax(90px, 1fr) auto;
  justify-items: center;
  gap: 5px;
  color: #334155;
  font-size: 11px;
}

.factor-accident-bar-value {
  color: #0f172a;
  font-weight: 800;
}

.factor-accident-bar {
  min-height: 8px;
  align-self: end;
  border-radius: 7px 7px 3px 3px;
  background: var(--factor-risk-color, #94a3b8);
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.12);
}

.factor-accident-bar-label {
  max-width: 58px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.factor-mini-bar-row {
  display: grid;
  grid-template-columns: minmax(86px, 1.1fr) minmax(80px, 1.4fr) 34px;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
  color: #334155;
  font-size: 11px;
}

.factor-mini-bar-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.factor-mini-bar-track {
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e2e8f0;
}

.factor-mini-bar-fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--factor-risk-color, #94a3b8);
}

.factor-mini-bar-fill.is-factor {
  background: #2563eb;
}

.factor-mini-bar-value {
  color: #0f172a;
  font-weight: 800;
  text-align: right;
}

.factor-risk-card {
  background:
    radial-gradient(circle at 15% 0%, rgba(45, 212, 191, 0.08), transparent 42%),
    rgba(248, 250, 252, 0.92);
}

.factor-popup-risk-title {
  margin: 2px 0 8px;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.factor-popup-table-details {
  margin-top: 2px;
  color: #475569;
  font-size: 11px;
}

.factor-popup-table-details > summary {
  padding: 5px 2px;
  cursor: pointer;
  font-weight: 700;
}

.factor-popup-table-details[open] > summary {
  margin-bottom: 5px;
}

.factor-risk-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.factor-risk-row {
  --factor-accent: #64748b;
  --factor-accent-soft: rgba(100, 116, 139, 0.18);
  display: grid;
  grid-template-columns: minmax(145px, 1fr) minmax(98px, auto);
  align-items: center;
  gap: 8px;
}

.factor-risk-row.is-down {
  --factor-accent: #0f9f91;
  --factor-accent-soft: rgba(20, 184, 166, 0.2);
}

.factor-risk-row.is-up {
  --factor-accent: #e44f5e;
  --factor-accent-soft: rgba(244, 63, 94, 0.18);
}

.factor-risk-track {
  position: relative;
  min-width: 0;
  height: 38px;
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--factor-accent) 25%, #e2e8f0);
  border-radius: 7px;
  background: color-mix(in srgb, var(--factor-accent) 6%, #f8fafc);
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);
}

.factor-risk-fill {
  position: absolute;
  inset: 0 auto 0 0;
  min-width: 8%;
  border-radius: 6px;
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--factor-accent) 30%, #ffffff),
    color-mix(in srgb, var(--factor-accent) 82%, #ffffff)
  );
  opacity: 0.92;
}

.factor-risk-main {
  position: relative;
  z-index: 1;
  height: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr) auto;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  color: #1e293b;
  font-size: 11px;
}

.factor-risk-icon {
  font-size: 14px;
  line-height: 1;
  text-align: center;
  filter: saturate(0.9);
}

.factor-risk-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.factor-risk-percent {
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.factor-risk-direction {
  color: var(--factor-accent);
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.factor-risk-explanation {
  margin-top: 2px;
  padding: 7px 9px;
  border: 1px dashed #94a3b8;
  border-radius: 7px;
  background: rgba(241, 245, 249, 0.82);
  color: #475569;
  font-size: 10px;
  line-height: 1.45;
}

@media (max-width: 1100px) {
  .factor-risk-row {
    grid-template-columns: 1fr;
    gap: 3px;
  }

  .factor-risk-direction {
    padding-left: 4px;
  }
}

.factor-line-chart-wrap {
  min-width: 0;
}

.factor-line-chart {
  width: 100%;
  height: 260px;
  display: block;
}

.factor-line-grid {
  stroke: #e2e8f0;
  stroke-width: 1;
}

.factor-line-axis {
  stroke: #94a3b8;
  stroke-width: 1;
}

.factor-line-axis-label {
  fill: #64748b;
  font-size: 10px;
}

.factor-line-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  margin-top: 6px;
  color: #334155;
  font-size: 11px;
}

.factor-line-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.factor-line-legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 999px;
}

@media (max-width: 1280px) {
  .factor-selection-chart-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 980px) {
  .factor-selection-main-grid,
  .factor-selection-chart-grid {
    grid-template-columns: 1fr;
  }
}

.codd-legend-slot .map-legend {
  position: static;
  left: auto;
  right: auto;
  bottom: auto;
  align-items: stretch;
}

.codd-legend-slot .map-legend-body {
  width: 100%;
  max-height: min(45vh, 420px);
}

.codd-bottom-button {
  width: min(320px, calc(100vw - 24px));
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.codd-map-workspace .leaflet-control-zoom {
  margin-bottom: 0;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.2);
}

.codd-map-workspace .leaflet-bottom.leaflet-left .leaflet-control {
  margin-left: 12px;
  margin-bottom: 12px;
}

.codd-map-workspace .leaflet-control-zoom a {
  border: none;
  color: #fff;
  background: rgba(17, 24, 39, 0.92);
}

.codd-map-workspace .leaflet-control-zoom a:hover {
  background: rgba(31, 41, 55, 0.96);
  color: #fff;
}

.codd-map-workspace .offcanvas.offcanvas-bottom {
  height: min(420px, 52vh) !important;
}

.codd-map-error {
  position: absolute;
  left: 50%;
  top: 24px;
  transform: translateX(-50%);
  z-index: 1500;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(127, 29, 29, 0.94);
  color: #fff;
  font-size: 13px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);
}

@media (max-width: 900px) {
  .codd-map-workspace {
    min-height: calc(100vh - 56px);
    height: auto;
    overflow: auto;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .codd-map-canvas {
    order: 1;
    min-height: 60vh;
    border-radius: 14px;
    overflow: hidden;
  }

  .codd-bottom-stack {
    position: static;
    width: 100%;
    max-width: none;
  }

  .codd-bottom-stack {
    order: 4;
    align-items: stretch;
  }

  .codd-legend-slot {
    width: 100%;
  }

  .codd-settings-trigger {
    position: static;
    order: 2;
  }

  .codd-search-trigger {
    position: static;
    order: 3;
  }

  .codd-top-right-rail {
    position: static;
    order: 4;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .codd-data-source-switch {
    order: 1;
  }

  .codd-period-summary {
    order: 0;
    flex: 1 1 100%;
    align-items: flex-start;
  }

  .codd-date-summary,
  .codd-road-year-summary {
    text-align: left;
  }

  .codd-date-trigger {
    position: static;
    order: 2;
  }

  .codd-road-date-trigger {
    position: static;
    order: 1;
  }

  .codd-district-trigger {
    position: static;
    order: 3;
  }

  .codd-top-left-rail {
    position: static;
    order: 2;
    gap: 12px;
    flex-wrap: wrap;
  }

  .codd-drawer {
    width: 100%;
  }
}

/* Analysis for a selected hex is intentionally a right-side drawer rather
   than a Leaflet popup: both model datasets can then be compared in place. */
.factor-selection-drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  z-index: 1100;
  container: factor-drawer / inline-size;
  width: min(var(--factor-selection-drawer-width, 460px), 100vw);
  transform: translateX(100%);
  opacity: 0;
  pointer-events: none;
  will-change: transform, opacity;
  transition: transform 0.25s ease, opacity 0.2s ease, width 0.25s ease;
}

.factor-selection-drawer.is-open {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}

.factor-selection-drawer.is-resizing {
  transition: none;
  -webkit-user-select: none;
          user-select: none;
}

.factor-drawer-sheet {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 18px;
  border-left: 1px solid #cbd5e1;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: -14px 0 34px rgba(15, 23, 42, 0.18);
  color: #1f2937;
  font-family: "Segoe UI", Tahoma, sans-serif;
}

.factor-drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.factor-drawer-title {
  color: #0f172a;
  font-size: 16px;
  font-weight: 800;
}

.factor-drawer-hex {
  margin-top: 3px;
  color: #64748b;
  font-family: Consolas, "Courier New", monospace;
  font-size: 11px;
}

.factor-drawer-close {
  display: grid;
  width: 30px;
  height: 30px;
  padding: 0;
  place-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.factor-drawer-close:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.factor-drawer-resize-handle {
  position: absolute;
  top: 18px;
  left: -15px;
  z-index: 2;
  display: grid;
  width: 30px;
  height: 42px;
  padding: 0;
  place-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 9px 0 0 9px;
  background: #fff;
  color: #475569;
  font-size: 20px;
  line-height: 1;
  cursor: ew-resize;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.factor-drawer-resize-handle:hover,
.factor-selection-drawer.is-resizing .factor-drawer-resize-handle {
  border-color: #94a3b8;
  background: #f1f5f9;
}

.factor-drawer-color {
  margin: 13px 0 4px;
  padding: 9px 10px;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #f8fafc;
}

.factor-drawer-color-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.factor-drawer-color-toggle,
.factor-drawer-color-source {
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  color: #475569;
  background: #fff;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.factor-drawer-color-toggle {
  min-width: 42px;
  padding: 3px 7px;
}

.factor-drawer-color-toggle.is-active {
  border-color: #86efac;
  color: #166534;
  background: #f0fdf4;
}

.factor-drawer-color-mode {
  display: grid;
  grid-template-columns: 1fr minmax(150px, 1.4fr);
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.factor-drawer-color-mode select {
  min-width: 0;
  padding: 4px 7px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  color: #334155;
  background: #fff;
  font: inherit;
  font-size: 11px;
}

.factor-drawer-color-sources {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.factor-drawer-color-source {
  padding: 4px 7px;
}

.factor-drawer-color-source.is-active {
  border-color: #93c5fd;
  color: #1d4ed8;
  background: #eff6ff;
}

.factor-drawer-color-legend {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 3px 8px;
  margin-top: 8px;
}

.factor-drawer-color-legend .color-legend-item {
  min-width: 0;
  font-size: 10px;
}

.factor-drawer-color-note {
  grid-column: 1 / -1;
  color: #94a3b8;
  font-size: 11px;
}

.factor-drawer-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin: 18px 0 12px;
  padding: 4px;
  border-radius: 10px;
  background: #f1f5f9;
}

.factor-drawer-tab {
  min-height: 34px;
  padding: 6px 8px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #475569;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.factor-drawer-tab.is-active {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.14);
}

.factor-drawer-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding-right: 2px;
}

@keyframes factor-drawer-bar-fill {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

@keyframes factor-drawer-bar-bounce {
  0% { transform: scaleX(0); }
  68% { transform: scaleX(1.09); }
  84% { transform: scaleX(0.96); }
  100% { transform: scaleX(1); }
}

.factor-drawer-content.is-direction-animating .factor-direction-bar i,
.factor-drawer-content.is-mini-animating .factor-mini-bar-fill,
.factor-drawer-content.is-risk-animating .factor-risk-fill,
.factor-drawer-content.is-comparison-animating .factor-comparison-bar i {
  transform-origin: left center;
  animation: factor-drawer-bar-fill 700ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.factor-drawer-content .factor-mini-bar-fill,
.factor-drawer-content .factor-risk-fill {
  transform-origin: left center;
}

.factor-drawer-content .factor-accident-bar {
  transform-origin: center bottom;
}

.factor-drawer-content.is-ts-animating .factor-ts-chart-track i {
  animation: factor-drawer-bar-bounce 850ms ease-out both;
}

.factor-drawer-content.is-direction-animating .factor-direction-bar i {
  animation-delay: var(--factor-drawer-direction-delay, 0ms);
}

.factor-drawer-content.is-mini-animating .factor-mini-bar-fill {
  animation-delay: var(--factor-drawer-mini-delay, 0ms);
}

.factor-drawer-content.is-risk-animating .factor-risk-fill {
  animation-delay: var(--factor-drawer-risk-delay, 0ms);
}

.factor-drawer-content.is-comparison-animating .factor-comparison-bar i {
  animation-delay: var(--factor-drawer-comparison-delay, 0ms);
}

.factor-drawer-content.is-ts-animating .factor-ts-chart-track i {
  animation-delay: var(--factor-drawer-ts-delay, 0ms);
}

.factor-drawer-content .factor-ts-chart-track i.is-up {
  transform-origin: left center;
}

.factor-drawer-content .factor-ts-chart-track i.is-down {
  transform-origin: right center;
}

@media (prefers-reduced-motion: reduce) {
  .factor-drawer-content.is-direction-animating .factor-direction-bar i,
  .factor-drawer-content.is-mini-animating .factor-mini-bar-fill,
  .factor-drawer-content.is-risk-animating .factor-risk-fill,
  .factor-drawer-content.is-comparison-animating .factor-comparison-bar i,
  .factor-drawer-content.is-ts-animating .factor-ts-chart-track i {
    animation: none;
  }
}

.factor-drawer-view-toggle {
  margin: 0 0 10px auto;
  padding: 5px 9px;
  border: 1px solid #bfdbfe;
  border-radius: 7px;
  background: #eff6ff;
  color: #1d4ed8;
  font: inherit;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.factor-drawer-content .factor-analysis-block {
  min-width: 0;
  max-width: none;
}

.factor-drawer-info-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 10px;
}

.factor-drawer-info-grid > * {
  min-width: 0;
  margin: 0;
}

.factor-drawer-info-grid > .factor-raw-dtp-info,
.factor-drawer-data-section {
  padding: 10px;
  border: 1px solid #dbe3ef;
  border-radius: 9px;
  background: #fff;
}

.factor-drawer-data-section .factor-analysis-meta {
  grid-template-columns: minmax(0, 1fr);
  margin: 7px 0;
}

.factor-drawer-groups-section {
  margin-top: 4px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.factor-drawer-groups-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.factor-drawer-groups-help {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 30px;
  margin-left: auto;
  padding: 4px 8px;
  border: 1px solid #bfdbfe;
  border-radius: 7px;
  background: #eff6ff;
  color: #1d4ed8;
  font: inherit;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.factor-drawer-groups-help:hover,
.factor-drawer-groups-help:focus-visible {
  border-color: #60a5fa;
  background: #dbeafe;
}

.factor-drawer-groups-help span {
  display: inline-grid;
  place-items: center;
  width: 16px;
  height: 16px;
  border: 1px solid currentColor;
  border-radius: 50%;
  font-size: 10px;
  line-height: 1;
}

.factor-drawer-groups-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(190px, 1fr));
  align-items: start;
  gap: 10px;
  max-width: 650px;
  overflow-x: auto;
}

.factor-drawer-groups-grid > * {
  min-width: 0;
  margin: 0;
}

.factor-drawer-group-summary {
  margin: 0 0 10px;
  padding: 8px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  color: #1d4ed8;
  background: #eff6ff;
  font-size: 12px;
}

.factor-drawer-comparison-card {
  margin: 0 0 10px;
  padding: 10px;
  overflow: hidden;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #fff;
}

.factor-drawer-comparison-pair {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  width: 100%;
  max-width: 860px;
  margin-bottom: 10px;
}

.factor-drawer-comparison-pair > .factor-drawer-comparison-card {
  min-width: 0;
  margin: 0;
}

.factor-drawer-comparison-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.factor-drawer-comparison-card .factor-selection-table-wrap {
  max-height: 265px;
}

.factor-drawer-comparison-card .factor-accident-chart {
  min-height: 118px;
}

.factor-category-tba {
  margin-top: 14px;
  padding: 10px 11px;
  border: 1px dashed #cbd5e1;
  border-radius: 9px;
  color: #64748b;
  background: #f8fafc;
  font-size: 12px;
  line-height: 1.4;
}

.factor-category-tba-title {
  margin-bottom: 3px;
  color: #475569;
  font-weight: 800;
}

.factor-category-tba-title b {
  margin-left: 5px;
  padding: 1px 5px;
  border-radius: 4px;
  color: #64748b;
  background: #e2e8f0;
  font-size: 10px;
  letter-spacing: 0.04em;
}

.factor-drawer-hex-info {
  margin: 0 0 12px;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  line-height: 1.45;
}

.factor-drawer-hex-info summary {
  cursor: pointer;
  color: #334155;
  font-weight: 800;
}

.factor-drawer-hex-info .popup-content {
  margin-top: 8px;
}

.factor-comparison-block {
  margin: 0;
}

.factor-comparison-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 10px 0;
}

.factor-comparison-card {
  min-width: 0;
  padding: 11px;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #f8fafc;
}

.factor-comparison-card.is-prediction {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.factor-comparison-card.is-actual {
  border-color: #fecaca;
  background: #fff7f7;
}

.factor-comparison-label {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.factor-comparison-value {
  margin: 5px 0 7px;
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
}

.factor-comparison-probability {
  color: #475569;
  font-size: 11px;
  line-height: 1.4;
}

.factor-comparison-bar {
  height: 7px;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 6px;
  background: #dbeafe;
}

.factor-comparison-bar i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2563eb;
}

.factor-comparison-outcome {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  color: #475569;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 700;
}

.factor-comparison-outcome b {
  display: grid;
  width: 20px;
  height: 20px;
  place-items: center;
  border-radius: 50%;
  font-size: 13px;
}

.factor-comparison-outcome.is-better {
  border-color: #86efac;
  background: #f0fdf4;
  color: #166534;
}

.factor-comparison-outcome.is-better b {
  background: #22c55e;
  color: #fff;
}

.factor-comparison-outcome.is-worse {
  border-color: #fecaca;
  background: #fff1f2;
  color: #b91c1c;
}

.factor-comparison-outcome.is-worse b {
  background: #ef4444;
  color: #fff;
}

.factor-comparison-outcome.is-ideal {
  border-color: #86efac;
  background: #f0fdf4;
  color: #166534;
}

.factor-comparison-outcome.is-ideal b {
  background: #22c55e;
  color: #fff;
}

.factor-comparison-outcome.is-critical {
  border-color: #fecaca;
  background: #fff1f2;
  color: #b91c1c;
}

.factor-comparison-outcome.is-critical b {
  background: #ef4444;
  color: #fff;
}

.factor-comparison-outcome.is-pending b {
  background: #cbd5e1;
  color: #334155;
}

.factor-hex-hover-tooltip {
  min-width: 245px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.2);
  color: #1e293b;
}

.factor-hex-comparison-canvas {
  pointer-events: none;
}

.factor-hex-hover-tooltip::before {
  border-top-color: #fff;
}

.factor-hex-hover-card {
  padding: 11px 13px;
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 12px;
}

.factor-hex-hover-id {
  margin-bottom: 7px;
  color: #64748b;
  font-family: Consolas, "Courier New", monospace;
  font-size: 11px;
}

.factor-hex-hover-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin: 4px 0;
}

.factor-hex-hover-row span {
  color: #64748b;
}

.factor-hex-hover-row b {
  color: #1e293b;
  text-align: right;
}

.factor-hex-hover-row i {
  display: inline-grid;
  width: 15px;
  height: 15px;
  margin-left: 3px;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  font-size: 10px;
  font-style: normal;
}

.factor-hex-hover-row i.is-better { background: #38bdf8; }
.factor-hex-hover-row i.is-worse { background: #f59e0b; }
.factor-hex-hover-row i.is-critical { background: #dc2626; }
.factor-hex-hover-row i.is-ideal { background: #16a34a; }
.factor-hex-hover-row i.is-pending { background: #94a3b8; }

.factor-hex-hover-hint {
  margin-top: 9px;
  color: #2563eb;
  font-size: 11px;
  font-weight: 700;
}

@media (max-width: 640px) {
  .factor-selection-drawer {
    width: 100%;
  }

  .factor-drawer-tabs {
    grid-template-columns: 1fr 1fr;
  }
}

@container factor-drawer (min-width: 610px) {
  .factor-drawer-info-grid {
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  }

  .factor-drawer-info-grid > * {
    width: 100%;
    max-width: 300px;
  }

  .factor-drawer-color,
  .factor-drawer-hex-info,
  .factor-recommendation-overview {
    max-width: 540px;
  }

  .factor-recommendation-overview {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    align-items: start;
  }

  .factor-drawer-group-summary {
    max-width: 320px;
  }

  .factor-drawer-content .factor-analysis-top .factor-analysis-meta,
  .factor-drawer-content .factor-actual-summary,
  .factor-drawer-content .factor-ts-metrics,
  .factor-drawer-content .dtp-history-summary,
  .factor-drawer-content .factor-comparison-cards,
  .factor-drawer-content .factor-actual-dtp-list,
  .factor-drawer-content .factor-actual-dtp-summary-list {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    align-items: start;
  }

  .factor-drawer-content .factor-analysis-top .factor-analysis-meta > *,
  .factor-drawer-content .factor-actual-summary > *,
  .factor-drawer-content .factor-ts-metrics > *,
  .factor-drawer-content .dtp-history-summary > * {
    width: 100%;
    max-width: 210px;
  }

  .factor-drawer-content .factor-comparison-cards,
  .factor-drawer-content .factor-actual-dtp-list,
  .factor-drawer-content .factor-actual-dtp-summary-list {
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  }

  .factor-drawer-info-grid .factor-actual-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .factor-drawer-content .factor-comparison-cards > *,
  .factor-drawer-content .factor-actual-dtp-list > *,
  .factor-drawer-content .factor-actual-dtp-summary-list > * {
    width: 100%;
    max-width: 320px;
  }

  .factor-drawer-content .factor-comparison-outcome,
  .factor-drawer-content .dtp-participant-search {
    max-width: 560px;
  }
}

@container factor-drawer (min-width: 650px) {
  .factor-drawer-comparison-pair {
    grid-template-columns: minmax(240px, 320px) minmax(330px, 530px);
  }
}

@container factor-drawer (max-width: 700px) {
  .factor-drawer-groups-grid .factor-group-dominance-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .factor-drawer-groups-grid .factor-group-dominance-rows {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/personal/map_workspace.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB;;;;;mCAKiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,WAAW;EACX,4DAA4D;EAC5D,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;EACd,qBAAqB;EACrB,2CAA2C;EAC3C,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qCAAqC;EACrC,cAAc;EACd,8CAA8C;EAC9C,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,cAAc;EACd,+CAA+C;EAC/C,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;;6BAE2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uEAAuE;EACvE,kBAAkB;EAClB,gEAAgE;EAChE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB;;;;GAIC;EACD,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE;IACE,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,uBAAuB;EACzB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;6EAC6E;AAC7E;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,sCAAsC;EACtC,8DAA8D;EAC9D,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,+BAA+B;EAC/B,qEAAqE;AACvE;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,+CAA+C;EAC/C,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,KAAK,oBAAoB,EAAE;EAC3B,MAAM,uBAAuB,EAAE;EAC/B,MAAM,uBAAuB,EAAE;EAC/B,OAAO,oBAAoB,EAAE;AAC/B;;AAEA;;;;EAIE,6BAA6B;EAC7B,2EAA2E;AAC7E;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;;;;;IAKE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,oCAAoC,mBAAmB,EAAE;AACzD,mCAAmC,mBAAmB,EAAE;AACxD,sCAAsC,mBAAmB,EAAE;AAC3D,mCAAmC,mBAAmB,EAAE;AACxD,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;;IAOE,4DAA4D;IAC5D,kBAAkB;EACpB;;EAEA;;;;IAIE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,4DAA4D;EAC9D;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;;IAGE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gEAAgE;EAClE;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".codd-map-workspace {\n  position: relative;\n  height: calc(100vh - 56px);\n  min-height: 720px;\n  overflow: hidden;\n  background: #dbe4ee;\n}\n\n.codd-map-canvas {\n  height: 100%;\n  width: 100%;\n}\n\n.codd-top-left-rail {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 1000;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.codd-settings-trigger {\n  position: static;\n}\n\n.codd-search-trigger {\n  position: static;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.factor-data-source-status {\n  display: inline-flex;\n  align-items: center;\n  min-height: 34px;\n  max-width: 250px;\n  padding: 7px 10px;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 8px;\n  background: rgba(15, 23, 42, 0.92);\n  color: #f8fafc;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.2;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);\n}\n\n.factor-data-source-status.is-ready {\n  border-color: #34d399;\n}\n\n.factor-data-source-status.is-partial {\n  border-color: #fbbf24;\n}\n\n.factor-data-source-status.is-error {\n  border-color: #fb7185;\n}\n\n.map-load-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 34px;\n  color: #e2e8f0;\n}\n\n.map-load-spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid rgba(226, 232, 240, 0.34);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: codd-map-spin 0.8s linear infinite;\n}\n\n.map-load-public-text {\n  padding: 7px 9px;\n  border-radius: 7px;\n  background: rgba(15, 23, 42, 0.9);\n  color: #f8fafc;\n  font-size: 12px;\n  font-weight: 650;\n  line-height: 1.2;\n  white-space: nowrap;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);\n}\n\n.map-load-progress-wrap {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 180px;\n}\n\n.map-load-progress-track {\n  display: block;\n  width: 100%;\n  height: 4px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: rgba(226, 232, 240, 0.38);\n}\n\n.map-load-progress-value {\n  display: block;\n  height: 100%;\n  min-width: 0;\n  border-radius: inherit;\n  background: #34d399;\n  transition: width 650ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.map-load-developer-text {\n  max-width: 250px;\n  padding: 6px 8px;\n  border-radius: 7px;\n  background: rgba(15, 23, 42, 0.9);\n  color: #f8fafc;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n@keyframes codd-map-spin {\n  to { transform: rotate(360deg); }\n}\n\n.codd-top-right-rail {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.codd-data-source-switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 34px;\n  padding: 7px 10px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 8px;\n  background: rgba(17, 24, 39, 0.92);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.15;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);\n}\n\n.codd-data-source-switch input {\n  width: 14px;\n  height: 14px;\n  margin: 0;\n  accent-color: #22c55e;\n  cursor: pointer;\n}\n\n.codd-date-trigger,\n.codd-road-date-trigger,\n.codd-district-trigger {\n  position: static;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.codd-period-summary {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  max-width: 260px;\n}\n\n.codd-date-panel {\n  border-top: none;\n  padding-top: 0;\n}\n\n.codd-date-summary,\n.codd-road-year-summary {\n  max-width: 240px;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-align: right;\n  text-shadow:\n    -1px -1px 0 rgba(15, 23, 42, 0.95),\n    1px -1px 0 rgba(15, 23, 42, 0.95),\n    -1px 1px 0 rgba(15, 23, 42, 0.95),\n    1px 1px 0 rgba(15, 23, 42, 0.95),\n    0 1px 2px rgba(15, 23, 42, 0.9);\n}\n\n.codd-road-year-summary {\n  opacity: 0.95;\n}\n\n.codd-settings-sheet {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  color: #1d1d1d;\n  font-family: \"Segoe UI\", Tahoma, sans-serif;\n  font-size: 13px;\n}\n\n.codd-drawer-backdrop {\n  position: absolute;\n  inset: 0;\n  z-index: 1090;\n  background: rgba(15, 23, 42, 0.32);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.codd-drawer-backdrop.is-open {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.codd-drawer {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1100;\n  width: min(420px, calc(100vw - 24px));\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.22);\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.25s ease;\n}\n\n.codd-drawer-left {\n  left: 0;\n  transform: translateX(-102%);\n}\n\n.codd-drawer-right {\n  right: 0;\n  transform: translateX(102%);\n}\n\n.codd-drawer.is-open {\n  transform: translateX(0);\n}\n\n.codd-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 18px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.codd-drawer-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.codd-drawer-close {\n  border: none;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  padding: 0;\n  background: rgba(17, 24, 39, 0.94);\n  color: #fff;\n  cursor: pointer;\n  font-size: 22px;\n  line-height: 1;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);\n}\n\n.codd-drawer-close:hover {\n  background: rgba(31, 41, 55, 0.98);\n}\n\n.codd-drawer-close svg {\n  flex: 0 0 auto;\n}\n\n.codd-drawer-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  overflow: auto;\n  padding: 16px 18px 20px;\n}\n\n.codd-bottom-stack {\n  position: absolute;\n  right: 12px;\n  bottom: 12px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n}\n\n.codd-legend-slot {\n  width: min(320px, calc(100vw - 24px));\n}\n\n.factor-selection-drawer {\n  --factor-tab-height: 42px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1001;\n  width: 100%;\n  transform: translateY(calc(100% - var(--factor-tab-height)));\n  transition: transform 260ms ease;\n  pointer-events: none;\n}\n\n.factor-selection-drawer.is-open {\n  transform: translateY(0);\n}\n\n.factor-selection-tab {\n  position: relative;\n  width: min(240px, 70%);\n  min-height: var(--factor-tab-height);\n  margin: 0 auto;\n  padding: 7px 14px 8px;\n  border: 1px solid rgba(148, 163, 184, 0.75);\n  border-bottom: none;\n  border-radius: 14px 14px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.98);\n  color: #0f172a;\n  box-shadow: 0 -8px 22px rgba(15, 23, 42, 0.14);\n  cursor: pointer;\n  font-family: \"Segoe UI\", Tahoma, sans-serif;\n  touch-action: none;\n  user-select: none;\n  pointer-events: auto;\n}\n\n.factor-selection-drawer.is-open .factor-selection-tab {\n  cursor: ns-resize;\n}\n\n.factor-selection-tab-grip {\n  position: absolute;\n  top: 5px;\n  width: 42px;\n  height: 4px;\n  border-radius: 999px;\n  background: #cbd5e1;\n}\n\n.factor-selection-tab-icon {\n  width: 13px;\n  height: 13px;\n  border-top: 3px solid #0f172a;\n  border-left: 3px solid #0f172a;\n  transform: rotate(45deg) translateY(2px);\n  transition: transform 180ms ease;\n}\n\n.factor-selection-drawer.is-open .factor-selection-tab-icon {\n  transform: rotate(225deg) translateY(-2px);\n}\n\n.factor-selection-drawer.is-open .factor-selection-tab {\n  border-color: #cbd5e1;\n  box-shadow: 0 -4px 14px rgba(15, 23, 42, 0.1);\n}\n\n.factor-selection-sheet {\n  display: flex;\n  flex-direction: column;\n  max-height: min(42vh, 390px);\n  overflow: auto;\n  padding: 12px 18px;\n  border: 1px solid rgba(148, 163, 184, 0.75);\n  border-left: none;\n  border-right: none;\n  border-radius: 14px 14px 0 0;\n  background: rgba(255, 255, 255, 0.97);\n  color: #1f2937;\n  box-shadow: 0 -12px 32px rgba(15, 23, 42, 0.18);\n  font-family: \"Segoe UI\", Tahoma, sans-serif;\n  pointer-events: auto;\n}\n\n.factor-selection-drawer.is-resized .factor-selection-sheet {\n  height: var(--factor-selection-sheet-height);\n  max-height: min(72vh, calc(100vh - 120px));\n}\n\n.factor-selection-drawer.is-collapsed .factor-selection-sheet {\n  pointer-events: none;\n}\n\n.factor-selection-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.factor-selection-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.factor-selection-main-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.9fr) minmax(280px, 0.9fr);\n  gap: 12px;\n  align-items: stretch;\n}\n\n.factor-selection-chart-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.factor-selection-card {\n  min-width: 0;\n  padding: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: rgba(248, 250, 252, 0.78);\n}\n\n.factor-selection-card.is-chart {\n  display: flex;\n  flex-direction: column;\n}\n\n.factor-selection-card-wide {\n  grid-column: span 2;\n}\n\n.factor-selection-card.is-table {\n  padding: 0;\n  background: transparent;\n}\n\n.factor-selection-card-title {\n  margin-bottom: 8px;\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.factor-selection-card-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n  padding: 0 2px;\n}\n\n.factor-selection-card-title-row .factor-selection-card-title {\n  margin-bottom: 0;\n}\n\n.factor-selection-card.is-table .factor-selection-card-title {\n  padding: 0 2px;\n}\n\n.factor-selection-empty {\n  min-height: 96px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 14px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  color: #64748b;\n  font-size: 12px;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.factor-selection-export-btn {\n  flex: 0 0 auto;\n  min-height: 26px;\n  padding: 4px 9px;\n  border: 1px solid #bfdbfe;\n  border-radius: 7px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 11px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.factor-selection-export-btn:hover:not(:disabled) {\n  border-color: #93c5fd;\n  background: #dbeafe;\n}\n\n.factor-selection-export-btn:disabled {\n  cursor: wait;\n  opacity: 0.55;\n}\n\n.factor-selection-note {\n  margin-bottom: 8px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.factor-selection-note.is-placeholder {\n  color: #dc2626;\n  font-weight: 800;\n}\n\n.factor-selection-table-wrap {\n  flex: 1 1 auto;\n  max-height: min(30vh, 270px);\n  overflow: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.84);\n}\n\n.factor-selection-drawer.is-resized .factor-selection-table-wrap {\n  max-height: none;\n}\n\n.factor-selection-table {\n  width: 100%;\n  min-width: 540px;\n  border-collapse: collapse;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.factor-selection-table th,\n.factor-selection-table td {\n  min-width: 140px;\n  max-width: 220px;\n  padding: 6px 8px;\n  border-bottom: 1px solid #e5e7eb;\n  border-right: 1px solid #eef2f7;\n  text-align: left;\n  vertical-align: top;\n}\n\n.factor-selection-table th:first-child {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  min-width: 96px;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.factor-selection-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.factor-selection-table thead th:first-child {\n  z-index: 3;\n}\n\n.factor-accident-chart {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-around;\n  gap: 8px;\n  overflow-x: auto;\n  padding: 8px 6px 0;\n}\n\n.factor-accident-bar-item {\n  flex: 1 1 0;\n  min-width: 28px;\n  max-width: 74px;\n  height: 100%;\n  min-height: 150px;\n  display: grid;\n  grid-template-rows: auto minmax(90px, 1fr) auto;\n  justify-items: center;\n  gap: 5px;\n  color: #334155;\n  font-size: 11px;\n}\n\n.factor-accident-bar-value {\n  color: #0f172a;\n  font-weight: 800;\n}\n\n.factor-accident-bar {\n  min-height: 8px;\n  align-self: end;\n  border-radius: 7px 7px 3px 3px;\n  background: var(--factor-risk-color, #94a3b8);\n  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.12);\n}\n\n.factor-accident-bar-label {\n  max-width: 58px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.factor-mini-bar-row {\n  display: grid;\n  grid-template-columns: minmax(86px, 1.1fr) minmax(80px, 1.4fr) 34px;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 7px;\n  color: #334155;\n  font-size: 11px;\n}\n\n.factor-mini-bar-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.factor-mini-bar-track {\n  height: 8px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #e2e8f0;\n}\n\n.factor-mini-bar-fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--factor-risk-color, #94a3b8);\n}\n\n.factor-mini-bar-fill.is-factor {\n  background: #2563eb;\n}\n\n.factor-mini-bar-value {\n  color: #0f172a;\n  font-weight: 800;\n  text-align: right;\n}\n\n.factor-risk-card {\n  background:\n    radial-gradient(circle at 15% 0%, rgba(45, 212, 191, 0.08), transparent 42%),\n    rgba(248, 250, 252, 0.92);\n}\n\n.factor-popup-risk-title {\n  margin: 2px 0 8px;\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.factor-popup-table-details {\n  margin-top: 2px;\n  color: #475569;\n  font-size: 11px;\n}\n\n.factor-popup-table-details > summary {\n  padding: 5px 2px;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.factor-popup-table-details[open] > summary {\n  margin-bottom: 5px;\n}\n\n.factor-risk-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.factor-risk-row {\n  --factor-accent: #64748b;\n  --factor-accent-soft: rgba(100, 116, 139, 0.18);\n  display: grid;\n  grid-template-columns: minmax(145px, 1fr) minmax(98px, auto);\n  align-items: center;\n  gap: 8px;\n}\n\n.factor-risk-row.is-down {\n  --factor-accent: #0f9f91;\n  --factor-accent-soft: rgba(20, 184, 166, 0.2);\n}\n\n.factor-risk-row.is-up {\n  --factor-accent: #e44f5e;\n  --factor-accent-soft: rgba(244, 63, 94, 0.18);\n}\n\n.factor-risk-track {\n  position: relative;\n  min-width: 0;\n  height: 38px;\n  overflow: hidden;\n  border: 1px solid color-mix(in srgb, var(--factor-accent) 25%, #e2e8f0);\n  border-radius: 7px;\n  background: color-mix(in srgb, var(--factor-accent) 6%, #f8fafc);\n  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.factor-risk-fill {\n  position: absolute;\n  inset: 0 auto 0 0;\n  min-width: 8%;\n  border-radius: 6px;\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--factor-accent) 30%, #ffffff),\n    color-mix(in srgb, var(--factor-accent) 82%, #ffffff)\n  );\n  opacity: 0.92;\n}\n\n.factor-risk-main {\n  position: relative;\n  z-index: 1;\n  height: 100%;\n  min-width: 0;\n  display: grid;\n  grid-template-columns: 20px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 6px;\n  padding: 0 9px;\n  color: #1e293b;\n  font-size: 11px;\n}\n\n.factor-risk-icon {\n  font-size: 14px;\n  line-height: 1;\n  text-align: center;\n  filter: saturate(0.9);\n}\n\n.factor-risk-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.factor-risk-percent {\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.factor-risk-direction {\n  color: var(--factor-accent);\n  font-size: 11px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.factor-risk-explanation {\n  margin-top: 2px;\n  padding: 7px 9px;\n  border: 1px dashed #94a3b8;\n  border-radius: 7px;\n  background: rgba(241, 245, 249, 0.82);\n  color: #475569;\n  font-size: 10px;\n  line-height: 1.45;\n}\n\n@media (max-width: 1100px) {\n  .factor-risk-row {\n    grid-template-columns: 1fr;\n    gap: 3px;\n  }\n\n  .factor-risk-direction {\n    padding-left: 4px;\n  }\n}\n\n.factor-line-chart-wrap {\n  min-width: 0;\n}\n\n.factor-line-chart {\n  width: 100%;\n  height: 260px;\n  display: block;\n}\n\n.factor-line-grid {\n  stroke: #e2e8f0;\n  stroke-width: 1;\n}\n\n.factor-line-axis {\n  stroke: #94a3b8;\n  stroke-width: 1;\n}\n\n.factor-line-axis-label {\n  fill: #64748b;\n  font-size: 10px;\n}\n\n.factor-line-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 10px;\n  margin-top: 6px;\n  color: #334155;\n  font-size: 11px;\n}\n\n.factor-line-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.factor-line-legend-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n}\n\n@media (max-width: 1280px) {\n  .factor-selection-chart-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 980px) {\n  .factor-selection-main-grid,\n  .factor-selection-chart-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.codd-legend-slot .map-legend {\n  position: static;\n  left: auto;\n  right: auto;\n  bottom: auto;\n  align-items: stretch;\n}\n\n.codd-legend-slot .map-legend-body {\n  width: 100%;\n  max-height: min(45vh, 420px);\n}\n\n.codd-bottom-button {\n  width: min(320px, calc(100vw - 24px));\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.codd-map-workspace .leaflet-control-zoom {\n  margin-bottom: 0;\n  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.2);\n}\n\n.codd-map-workspace .leaflet-bottom.leaflet-left .leaflet-control {\n  margin-left: 12px;\n  margin-bottom: 12px;\n}\n\n.codd-map-workspace .leaflet-control-zoom a {\n  border: none;\n  color: #fff;\n  background: rgba(17, 24, 39, 0.92);\n}\n\n.codd-map-workspace .leaflet-control-zoom a:hover {\n  background: rgba(31, 41, 55, 0.96);\n  color: #fff;\n}\n\n.codd-map-workspace .offcanvas.offcanvas-bottom {\n  height: min(420px, 52vh) !important;\n}\n\n.codd-map-error {\n  position: absolute;\n  left: 50%;\n  top: 24px;\n  transform: translateX(-50%);\n  z-index: 1500;\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: rgba(127, 29, 29, 0.94);\n  color: #fff;\n  font-size: 13px;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);\n}\n\n@media (max-width: 900px) {\n  .codd-map-workspace {\n    min-height: calc(100vh - 56px);\n    height: auto;\n    overflow: auto;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .codd-map-canvas {\n    order: 1;\n    min-height: 60vh;\n    border-radius: 14px;\n    overflow: hidden;\n  }\n\n  .codd-bottom-stack {\n    position: static;\n    width: 100%;\n    max-width: none;\n  }\n\n  .codd-bottom-stack {\n    order: 4;\n    align-items: stretch;\n  }\n\n  .codd-legend-slot {\n    width: 100%;\n  }\n\n  .codd-settings-trigger {\n    position: static;\n    order: 2;\n  }\n\n  .codd-search-trigger {\n    position: static;\n    order: 3;\n  }\n\n  .codd-top-right-rail {\n    position: static;\n    order: 4;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .codd-data-source-switch {\n    order: 1;\n  }\n\n  .codd-period-summary {\n    order: 0;\n    flex: 1 1 100%;\n    align-items: flex-start;\n  }\n\n  .codd-date-summary,\n  .codd-road-year-summary {\n    text-align: left;\n  }\n\n  .codd-date-trigger {\n    position: static;\n    order: 2;\n  }\n\n  .codd-road-date-trigger {\n    position: static;\n    order: 1;\n  }\n\n  .codd-district-trigger {\n    position: static;\n    order: 3;\n  }\n\n  .codd-top-left-rail {\n    position: static;\n    order: 2;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n\n  .codd-drawer {\n    width: 100%;\n  }\n}\n\n/* Analysis for a selected hex is intentionally a right-side drawer rather\n   than a Leaflet popup: both model datasets can then be compared in place. */\n.factor-selection-drawer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  z-index: 1100;\n  container: factor-drawer / inline-size;\n  width: min(var(--factor-selection-drawer-width, 460px), 100vw);\n  transform: translateX(100%);\n  opacity: 0;\n  pointer-events: none;\n  will-change: transform, opacity;\n  transition: transform 0.25s ease, opacity 0.2s ease, width 0.25s ease;\n}\n\n.factor-selection-drawer.is-open {\n  transform: translateX(0);\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.factor-selection-drawer.is-resizing {\n  transition: none;\n  user-select: none;\n}\n\n.factor-drawer-sheet {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  padding: 18px;\n  border-left: 1px solid #cbd5e1;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: -14px 0 34px rgba(15, 23, 42, 0.18);\n  color: #1f2937;\n  font-family: \"Segoe UI\", Tahoma, sans-serif;\n}\n\n.factor-drawer-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.factor-drawer-title {\n  color: #0f172a;\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.factor-drawer-hex {\n  margin-top: 3px;\n  color: #64748b;\n  font-family: Consolas, \"Courier New\", monospace;\n  font-size: 11px;\n}\n\n.factor-drawer-close {\n  display: grid;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  place-items: center;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.factor-drawer-close:hover {\n  border-color: #94a3b8;\n  background: #f8fafc;\n}\n\n.factor-drawer-resize-handle {\n  position: absolute;\n  top: 18px;\n  left: -15px;\n  z-index: 2;\n  display: grid;\n  width: 30px;\n  height: 42px;\n  padding: 0;\n  place-items: center;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px 0 0 9px;\n  background: #fff;\n  color: #475569;\n  font-size: 20px;\n  line-height: 1;\n  cursor: ew-resize;\n  touch-action: none;\n  user-select: none;\n}\n\n.factor-drawer-resize-handle:hover,\n.factor-selection-drawer.is-resizing .factor-drawer-resize-handle {\n  border-color: #94a3b8;\n  background: #f1f5f9;\n}\n\n.factor-drawer-color {\n  margin: 13px 0 4px;\n  padding: 9px 10px;\n  border: 1px solid #dbe3ef;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.factor-drawer-color-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.factor-drawer-color-toggle,\n.factor-drawer-color-source {\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  color: #475569;\n  background: #fff;\n  font: inherit;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.factor-drawer-color-toggle {\n  min-width: 42px;\n  padding: 3px 7px;\n}\n\n.factor-drawer-color-toggle.is-active {\n  border-color: #86efac;\n  color: #166534;\n  background: #f0fdf4;\n}\n\n.factor-drawer-color-mode {\n  display: grid;\n  grid-template-columns: 1fr minmax(150px, 1.4fr);\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.factor-drawer-color-mode select {\n  min-width: 0;\n  padding: 4px 7px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  color: #334155;\n  background: #fff;\n  font: inherit;\n  font-size: 11px;\n}\n\n.factor-drawer-color-sources {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.factor-drawer-color-source {\n  padding: 4px 7px;\n}\n\n.factor-drawer-color-source.is-active {\n  border-color: #93c5fd;\n  color: #1d4ed8;\n  background: #eff6ff;\n}\n\n.factor-drawer-color-legend {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 3px 8px;\n  margin-top: 8px;\n}\n\n.factor-drawer-color-legend .color-legend-item {\n  min-width: 0;\n  font-size: 10px;\n}\n\n.factor-drawer-color-note {\n  grid-column: 1 / -1;\n  color: #94a3b8;\n  font-size: 11px;\n}\n\n.factor-drawer-tabs {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 6px;\n  margin: 18px 0 12px;\n  padding: 4px;\n  border-radius: 10px;\n  background: #f1f5f9;\n}\n\n.factor-drawer-tab {\n  min-height: 34px;\n  padding: 6px 8px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #475569;\n  font: inherit;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.factor-drawer-tab.is-active {\n  background: #fff;\n  color: #1d4ed8;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.14);\n}\n\n.factor-drawer-content {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding-right: 2px;\n}\n\n@keyframes factor-drawer-bar-fill {\n  from { transform: scaleX(0); }\n  to { transform: scaleX(1); }\n}\n\n@keyframes factor-drawer-bar-bounce {\n  0% { transform: scaleX(0); }\n  68% { transform: scaleX(1.09); }\n  84% { transform: scaleX(0.96); }\n  100% { transform: scaleX(1); }\n}\n\n.factor-drawer-content.is-direction-animating .factor-direction-bar i,\n.factor-drawer-content.is-mini-animating .factor-mini-bar-fill,\n.factor-drawer-content.is-risk-animating .factor-risk-fill,\n.factor-drawer-content.is-comparison-animating .factor-comparison-bar i {\n  transform-origin: left center;\n  animation: factor-drawer-bar-fill 700ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.factor-drawer-content .factor-mini-bar-fill,\n.factor-drawer-content .factor-risk-fill {\n  transform-origin: left center;\n}\n\n.factor-drawer-content .factor-accident-bar {\n  transform-origin: center bottom;\n}\n\n.factor-drawer-content.is-ts-animating .factor-ts-chart-track i {\n  animation: factor-drawer-bar-bounce 850ms ease-out both;\n}\n\n.factor-drawer-content.is-direction-animating .factor-direction-bar i {\n  animation-delay: var(--factor-drawer-direction-delay, 0ms);\n}\n\n.factor-drawer-content.is-mini-animating .factor-mini-bar-fill {\n  animation-delay: var(--factor-drawer-mini-delay, 0ms);\n}\n\n.factor-drawer-content.is-risk-animating .factor-risk-fill {\n  animation-delay: var(--factor-drawer-risk-delay, 0ms);\n}\n\n.factor-drawer-content.is-comparison-animating .factor-comparison-bar i {\n  animation-delay: var(--factor-drawer-comparison-delay, 0ms);\n}\n\n.factor-drawer-content.is-ts-animating .factor-ts-chart-track i {\n  animation-delay: var(--factor-drawer-ts-delay, 0ms);\n}\n\n.factor-drawer-content .factor-ts-chart-track i.is-up {\n  transform-origin: left center;\n}\n\n.factor-drawer-content .factor-ts-chart-track i.is-down {\n  transform-origin: right center;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .factor-drawer-content.is-direction-animating .factor-direction-bar i,\n  .factor-drawer-content.is-mini-animating .factor-mini-bar-fill,\n  .factor-drawer-content.is-risk-animating .factor-risk-fill,\n  .factor-drawer-content.is-comparison-animating .factor-comparison-bar i,\n  .factor-drawer-content.is-ts-animating .factor-ts-chart-track i {\n    animation: none;\n  }\n}\n\n.factor-drawer-view-toggle {\n  margin: 0 0 10px auto;\n  padding: 5px 9px;\n  border: 1px solid #bfdbfe;\n  border-radius: 7px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font: inherit;\n  font-size: 11px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.factor-drawer-content .factor-analysis-block {\n  min-width: 0;\n  max-width: none;\n}\n\n.factor-drawer-info-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  align-items: start;\n  gap: 10px;\n}\n\n.factor-drawer-info-grid > * {\n  min-width: 0;\n  margin: 0;\n}\n\n.factor-drawer-info-grid > .factor-raw-dtp-info,\n.factor-drawer-data-section {\n  padding: 10px;\n  border: 1px solid #dbe3ef;\n  border-radius: 9px;\n  background: #fff;\n}\n\n.factor-drawer-data-section .factor-analysis-meta {\n  grid-template-columns: minmax(0, 1fr);\n  margin: 7px 0;\n}\n\n.factor-drawer-groups-section {\n  margin-top: 4px;\n  padding-top: 12px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.factor-drawer-groups-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.factor-drawer-groups-help {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 30px;\n  margin-left: auto;\n  padding: 4px 8px;\n  border: 1px solid #bfdbfe;\n  border-radius: 7px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font: inherit;\n  font-size: 11px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.factor-drawer-groups-help:hover,\n.factor-drawer-groups-help:focus-visible {\n  border-color: #60a5fa;\n  background: #dbeafe;\n}\n\n.factor-drawer-groups-help span {\n  display: inline-grid;\n  place-items: center;\n  width: 16px;\n  height: 16px;\n  border: 1px solid currentColor;\n  border-radius: 50%;\n  font-size: 10px;\n  line-height: 1;\n}\n\n.factor-drawer-groups-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(190px, 1fr));\n  align-items: start;\n  gap: 10px;\n  max-width: 650px;\n  overflow-x: auto;\n}\n\n.factor-drawer-groups-grid > * {\n  min-width: 0;\n  margin: 0;\n}\n\n.factor-drawer-group-summary {\n  margin: 0 0 10px;\n  padding: 8px 10px;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  color: #1d4ed8;\n  background: #eff6ff;\n  font-size: 12px;\n}\n\n.factor-drawer-comparison-card {\n  margin: 0 0 10px;\n  padding: 10px;\n  overflow: hidden;\n  border: 1px solid #dbe3ef;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.factor-drawer-comparison-pair {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  align-items: start;\n  gap: 10px;\n  width: 100%;\n  max-width: 860px;\n  margin-bottom: 10px;\n}\n\n.factor-drawer-comparison-pair > .factor-drawer-comparison-card {\n  min-width: 0;\n  margin: 0;\n}\n\n.factor-drawer-comparison-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.factor-drawer-comparison-card .factor-selection-table-wrap {\n  max-height: 265px;\n}\n\n.factor-drawer-comparison-card .factor-accident-chart {\n  min-height: 118px;\n}\n\n.factor-category-tba {\n  margin-top: 14px;\n  padding: 10px 11px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 9px;\n  color: #64748b;\n  background: #f8fafc;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.factor-category-tba-title {\n  margin-bottom: 3px;\n  color: #475569;\n  font-weight: 800;\n}\n\n.factor-category-tba-title b {\n  margin-left: 5px;\n  padding: 1px 5px;\n  border-radius: 4px;\n  color: #64748b;\n  background: #e2e8f0;\n  font-size: 10px;\n  letter-spacing: 0.04em;\n}\n\n.factor-drawer-hex-info {\n  margin: 0 0 12px;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 11px;\n  line-height: 1.45;\n}\n\n.factor-drawer-hex-info summary {\n  cursor: pointer;\n  color: #334155;\n  font-weight: 800;\n}\n\n.factor-drawer-hex-info .popup-content {\n  margin-top: 8px;\n}\n\n.factor-comparison-block {\n  margin: 0;\n}\n\n.factor-comparison-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin: 10px 0;\n}\n\n.factor-comparison-card {\n  min-width: 0;\n  padding: 11px;\n  border: 1px solid #dbe3ef;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.factor-comparison-card.is-prediction {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n}\n\n.factor-comparison-card.is-actual {\n  border-color: #fecaca;\n  background: #fff7f7;\n}\n\n.factor-comparison-label {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.factor-comparison-value {\n  margin: 5px 0 7px;\n  color: #0f172a;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.factor-comparison-probability {\n  color: #475569;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.factor-comparison-bar {\n  height: 7px;\n  margin-top: 8px;\n  overflow: hidden;\n  border-radius: 6px;\n  background: #dbeafe;\n}\n\n.factor-comparison-bar i {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: #2563eb;\n}\n\n.factor-comparison-outcome {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  color: #475569;\n  background: #f8fafc;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.factor-comparison-outcome b {\n  display: grid;\n  width: 20px;\n  height: 20px;\n  place-items: center;\n  border-radius: 50%;\n  font-size: 13px;\n}\n\n.factor-comparison-outcome.is-better {\n  border-color: #86efac;\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.factor-comparison-outcome.is-better b {\n  background: #22c55e;\n  color: #fff;\n}\n\n.factor-comparison-outcome.is-worse {\n  border-color: #fecaca;\n  background: #fff1f2;\n  color: #b91c1c;\n}\n\n.factor-comparison-outcome.is-worse b {\n  background: #ef4444;\n  color: #fff;\n}\n\n.factor-comparison-outcome.is-ideal {\n  border-color: #86efac;\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.factor-comparison-outcome.is-ideal b {\n  background: #22c55e;\n  color: #fff;\n}\n\n.factor-comparison-outcome.is-critical {\n  border-color: #fecaca;\n  background: #fff1f2;\n  color: #b91c1c;\n}\n\n.factor-comparison-outcome.is-critical b {\n  background: #ef4444;\n  color: #fff;\n}\n\n.factor-comparison-outcome.is-pending b {\n  background: #cbd5e1;\n  color: #334155;\n}\n\n.factor-hex-hover-tooltip {\n  min-width: 245px;\n  padding: 0;\n  border: 0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.2);\n  color: #1e293b;\n}\n\n.factor-hex-comparison-canvas {\n  pointer-events: none;\n}\n\n.factor-hex-hover-tooltip::before {\n  border-top-color: #fff;\n}\n\n.factor-hex-hover-card {\n  padding: 11px 13px;\n  font-family: \"Segoe UI\", Tahoma, sans-serif;\n  font-size: 12px;\n}\n\n.factor-hex-hover-id {\n  margin-bottom: 7px;\n  color: #64748b;\n  font-family: Consolas, \"Courier New\", monospace;\n  font-size: 11px;\n}\n\n.factor-hex-hover-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 4px 0;\n}\n\n.factor-hex-hover-row span {\n  color: #64748b;\n}\n\n.factor-hex-hover-row b {\n  color: #1e293b;\n  text-align: right;\n}\n\n.factor-hex-hover-row i {\n  display: inline-grid;\n  width: 15px;\n  height: 15px;\n  margin-left: 3px;\n  place-items: center;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 10px;\n  font-style: normal;\n}\n\n.factor-hex-hover-row i.is-better { background: #38bdf8; }\n.factor-hex-hover-row i.is-worse { background: #f59e0b; }\n.factor-hex-hover-row i.is-critical { background: #dc2626; }\n.factor-hex-hover-row i.is-ideal { background: #16a34a; }\n.factor-hex-hover-row i.is-pending { background: #94a3b8; }\n\n.factor-hex-hover-hint {\n  margin-top: 9px;\n  color: #2563eb;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n@media (max-width: 640px) {\n  .factor-selection-drawer {\n    width: 100%;\n  }\n\n  .factor-drawer-tabs {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@container factor-drawer (min-width: 610px) {\n  .factor-drawer-info-grid {\n    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));\n  }\n\n  .factor-drawer-info-grid > * {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .factor-drawer-color,\n  .factor-drawer-hex-info,\n  .factor-recommendation-overview {\n    max-width: 540px;\n  }\n\n  .factor-recommendation-overview {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    align-items: start;\n  }\n\n  .factor-drawer-group-summary {\n    max-width: 320px;\n  }\n\n  .factor-drawer-content .factor-analysis-top .factor-analysis-meta,\n  .factor-drawer-content .factor-actual-summary,\n  .factor-drawer-content .factor-ts-metrics,\n  .factor-drawer-content .dtp-history-summary,\n  .factor-drawer-content .factor-comparison-cards,\n  .factor-drawer-content .factor-actual-dtp-list,\n  .factor-drawer-content .factor-actual-dtp-summary-list {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    align-items: start;\n  }\n\n  .factor-drawer-content .factor-analysis-top .factor-analysis-meta > *,\n  .factor-drawer-content .factor-actual-summary > *,\n  .factor-drawer-content .factor-ts-metrics > *,\n  .factor-drawer-content .dtp-history-summary > * {\n    width: 100%;\n    max-width: 210px;\n  }\n\n  .factor-drawer-content .factor-comparison-cards,\n  .factor-drawer-content .factor-actual-dtp-list,\n  .factor-drawer-content .factor-actual-dtp-summary-list {\n    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));\n  }\n\n  .factor-drawer-info-grid .factor-actual-summary {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .factor-drawer-content .factor-comparison-cards > *,\n  .factor-drawer-content .factor-actual-dtp-list > *,\n  .factor-drawer-content .factor-actual-dtp-summary-list > * {\n    width: 100%;\n    max-width: 320px;\n  }\n\n  .factor-drawer-content .factor-comparison-outcome,\n  .factor-drawer-content .dtp-participant-search {\n    max-width: 560px;\n  }\n}\n\n@container factor-drawer (min-width: 650px) {\n  .factor-drawer-comparison-pair {\n    grid-template-columns: minmax(240px, 320px) minmax(330px, 530px);\n  }\n}\n\n@container factor-drawer (max-width: 700px) {\n  .factor-drawer-groups-grid .factor-group-dominance-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .factor-drawer-groups-grid .factor-group-dominance-rows {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
